<permission-checker [roles]="roles" (contentInit)="initContent()">
  <div class="content-holder">
    <mat-toolbar color="accent" class="page-toolbar" [class.mobile]="mobileView">
      <mat-toolbar-row class="toolbar-row">
        <h1 i18n="Competitions List|Competitions List title@@competitions-list-title">Competitions</h1>

        <div class="fill-space"></div>

        <app-button label="Create Competition"
                    i18n-label="Competitions List|Create Competition button title@@competitions-list-create-button-title"
                    color="primary"
                    (clicked)="createCompetition()"></app-button>
      </mat-toolbar-row>
    </mat-toolbar>

    <div class="content page">
      <app-no-content *ngIf="competitions && !competitions.length"
                      [compact]="true"
                      title="You don't have any competitions yet"
                      i18n-title="Competitions List|No competitions title@@competitions-list-no-items-title"
                      details="Start with creating a new competition"
                      i18n-details="Competitions List|No competitions details@@competitions-list-no-items-details">

        <app-button label="Create Competition"
                    i18n-label="Competitions List|Create Competition button title@@competitions-list-create-button-title"
                    class="center create-cta"
                    (clicked)="createCompetition()"></app-button>
      </app-no-content>

      <mat-spinner *ngIf="!competitions" color="primary" diameter="50" class="center"></mat-spinner>

      <mat-list class="list-container no-focus">
        <mat-list-item *ngFor="let competition of competitions" class="list-option no-focus"
                       (click)="showDetails(competition)">
          <div class="list-item-content full-width" fxLayout="row">
            <div fxLayout="column" fxFlex="60%" class="list-item-column competition-name">
            <span class="top text-disabled-color mat-small"
                  i18n="Competitions List|Competitions list item 'name' title@@competitions-list-item-name-title">Name:</span>
              <span class="word-wrap">{{competition.name}}</span>
            </div>
            <div fxLayout="column" fxFlex="30%" class="list-item-column competition-created">
            <span class="top text-disabled-color mat-small"
                  i18n="Competitions List|Competitions list item 'created at' title@@competitions-list-item-created-at-title">Created At:</span>
              <span>{{competition.createdAt | date:'medium'}}</span>
            </div>

            <div class="fill-space"></div>

            <div fxLayout="column" fxFlex="30px" class="list-actions">
              <mat-icon class="actions-icon"
                        [matMenuTriggerFor]="menu"
                        (click)="$event.stopPropagation()">more_vert
              </mat-icon>
              <mat-menu #menu="matMenu">
                <button mat-menu-item (click)="editCompetition(competition)">
                  <mat-icon>edit</mat-icon>
                  <span
                    i18n="General|Edit action label@@general-edit-action-label">Edit</span>
                </button>
                <button mat-menu-item (click)="deleteCompetition(competition)">
                  <mat-icon>delete</mat-icon>
                  <span
                    i18n="General|Delete action label@@general-delete-action-label">Delete</span>
                </button>
              </mat-menu>
            </div>
          </div>
        </mat-list-item>
      </mat-list>
    </div>
  </div>
</permission-checker>
